var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EditOverflowContainer"},[_c('div',{ref:"listContainer",staticClass:"EditOverflowContainer-MaxHeightWrapper",style:({ 'max-height': _vm.computedMaxHeight, visibility: _vm.visibility })},[(_vm.overflown)?_c('div',{staticClass:"gradient top",style:({
        opacity: _vm.gradient_top_opacity,
        visibility: _vm.gradient_visibility
      })}):_vm._e(),(_vm.overflown)?_c('div',{staticClass:"gradient bottom",style:({
        opacity: _vm.gradient_bottom_opacity,
        visibility: _vm.gradient_visibility
      })}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }